var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      ref: "dropzoneElement",
      class: { "vue-dropzone dropzone": _vm.includeStyling },
      attrs: { id: _vm.id }
    },
    [
      _vm.useCustomSlot
        ? _c(
            "div",
            { staticClass: "dz-message" },
            [_vm._t("default", [_vm._v("Drop files here to upload")])],
            2
          )
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-06af91f5", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-06af91f5","hasScoped":false,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/dropzone/dropzone.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-06af91f5","hasScoped":false,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/dropzone/dropzone.vue
// module chunks = 0 1 2 3